import { createContext } from 'react';

import { emptyFn } from '@app/constants';
import type { RecordModalState } from '@app/providers/RecordModalProvider/RecordModalProvider.types';

const defaultOnConfirmRef = { current: emptyFn };
const defaultOnAfterSaveRef = { current: emptyFn };

export const RecordModalContext = createContext<RecordModalState>({
  isCommentModal: false,
  setIsCommentModal: emptyFn,
  isNeedToUpdateRecordsRegistry: false,
  setIsNeedToUpdateRecordsRegistry: emptyFn,
  onConfirmRef: defaultOnConfirmRef,
  onAfterSaveRef: defaultOnAfterSaveRef,
});
